import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-toHide",
  "use": "icon-toHide-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-toHide\"><path d=\"M6 9C6 7.34315 7.34315 6 9 6H39C40.6569 6 42 7.34315 42 9V39C42 40.6569 40.6569 42 39 42H9C7.34315 42 6 40.6569 6 39V9Z\" fill=\"none\" stroke=\"#409EFF\" stroke-width=\"4\" stroke-linejoin=\"round\" /><path d=\"M32 6V42\" stroke=\"#409EFF\" stroke-width=\"4\" stroke-linecap=\"square\" stroke-linejoin=\"round\" /><path d=\"M16 20L20 24L16 28\" stroke=\"#409EFF\" stroke-width=\"4\" stroke-linecap=\"square\" stroke-linejoin=\"round\" /><path d=\"M26 6H38\" stroke=\"#409EFF\" stroke-width=\"4\" stroke-linecap=\"square\" stroke-linejoin=\"round\" /><path d=\"M26 42H38\" stroke=\"#409EFF\" stroke-width=\"4\" stroke-linecap=\"square\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/toHide.svg
// module id = Di1E
// module chunks = 103